<div class="row">
  <div class="col">
    <h2>Applicant Information</h2>
  </div>
</div>

<form [formGroup]="applicantFormGroup">
  <app-applicant-group
    [controls]="applicantFormGroup.controls"
  ></app-applicant-group>
</form>

<div class="row my-5">
  <div class="col-12 col-lg-6">
    <button
      [disabled]="isSaving"
      type="button"
      class="btn btn-primary"
      (click)="onNext()"
    >
      <span
        *ngIf="isSaving"
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      <span>Continue to Applicant Home & Vehicles</span>
      <i class="bi bi-chevron-right"></i>
    </button>

    <app-validation-text
      [show]="isDirtyAndMissingRequiredFields"
    ></app-validation-text>
  </div>
  <div *ngIf="applicantFormGroup.valid" class="col-12 col-lg-6">
    <div class="mt-3 mt-lg-0 text-center text-md-start text-lg-end">
      <button
        [disabled]="isSaving"
        class="btn btn-link"
        (click)="onFinishByPhone()"
      >
        <small> Finish Application by Phone </small>
      </button>
    </div>
  </div>
</div>
